import request from '../utils/request';

//列表页面
export function getActive(data) {
    return request({
        url: '/onlineExhibition/activityList',
        method: 'get',
        params: data,
    });
};

//活动收藏
export function collectActive(data) {
    //data.token = localStorage.getItem('viewToken');
    
    console.log("截取的参数是：",data);
    return request({
        url: '/onlineExhibition/addCollect',
        method: 'get',
        params: data,
    });
};

//活动详情
export function actDetail(data) {
    return request({
        url: '/onlineExhibition/activityDetail',
        method: 'get',
        params: data,
    });
};

//展商信息
export function exMsg(data) {
    return request({
        url: '/onlineExhibition/exhibitorDetails',
        method: 'get',
        params: data,
    });
};